import { type FC } from 'react'
import { Modal } from '../../../components/Modal/Modal'
import { type ButtonVariant } from '../../../components/Button/Button'

interface ConfirmDialogProps {
  title: string
  body: string
  confirmLabel?: string
  confirmVariant?: ButtonVariant
  cancelLabel?: string
  isLoading?: boolean
  centered?: boolean
  onConfirm: () => void
  onCancel: () => void
}

export const ConfirmDialog: FC<ConfirmDialogProps> = ({
  title,
  body,
  confirmLabel = 'Confirm',
  confirmVariant = 'danger',
  cancelLabel = 'Cancel',
  isLoading = false,
  centered = false,
  onConfirm,
  onCancel,
}) => {
  const handleCancel = () => {
    if (!isLoading) {
      onCancel()
    }
  }

  return (
    <Modal
      show
      centered={centered}
      footerClassName='p-4 pt-0'
      onHide={handleCancel}
      header={<h5 className='mb-0'>{title}</h5>}
      headerBodySeparator
      body={<div className='paragraph-medium'>{body}</div>}
      showFooterActions
      footerPrimaryActionTitle={confirmLabel}
      footerPrimaryActionButtonVariant={confirmVariant}
      footerPrimaryActionLoading={isLoading}
      footerSecondaryActionTitle={cancelLabel}
      footerSecondaryActionDisabled={isLoading}
      onFooterPrimaryAction={onConfirm}
      onFooterSecondaryAction={handleCancel}
    />
  )
}
